import React from "react";
import moment from "moment";

import { Pill, PILL_COLORS } from "components/ui/Pill";

export const formatDate = (date) => {
  if (!date) return "-";
  return moment(date).format("YYYY-MM-DD");
};

export const formatCurrency = (amount) => {
  if (!amount) return "€0.00";
  return `€${parseFloat(amount).toFixed(2)}`;
};

export const getPaymentPill = (status) => {
  const s = (status || "").toUpperCase();
  if (s === "PARTIAL") return <Pill {...PILL_COLORS.paymentPartial}>Partial</Pill>;
  if (s === "PAID") return <Pill {...PILL_COLORS.paymentPaid}>Paid</Pill>;
  return <Pill {...PILL_COLORS.paymentUnpaid}>Unpaid</Pill>;
};

export const FILTERS_CONFIG = [
  {
    id: "paymentStatus",
    label: "Payment Status",
    type: "single",
    options: [
      { value: "PAID", label: "Paid" },
      { value: "DUE", label: "Unpaid" },
      { value: "PARTIAL", label: "Partially Paid" },
    ],
  },
];
